<router-outlet></router-outlet>
<div *ngIf="(dynamicLayoutGuard?.loader)" id="loader-container">
  <div id="appSpinner" class="text-center">
    <i class="fas fa-circle-notch fa-spin fa-4x text-nau-trueblue"></i>
  </div>
</div>